__webpack_require__.p = "/quote-gen/";